import {
  TrackingInitialPageContext,
  TrackingPageTypeWithId,
  TrackingPageTypeWithoutId,
} from '../../../types'
import {
  TrackingClientStateHolder,
  InitialPageInfo,
  getShopId,
} from '../helpers/clientState'
import { stringifyEventData } from '../helpers/stringifyEventData'

export interface RouteChangeEvent {
  event: 'routeChange'
  shopVersion: string
  shopId: string
  timestamp: number
  contentName: string
  search: string
  pageType: TrackingPageTypeWithId | TrackingPageTypeWithoutId
  pageTypeId: null
}

export const trackRouteChange =
  ({ page }: { page: TrackingInitialPageContext }) =>
  (clientState: TrackingClientStateHolder): RouteChangeEvent => {
    let currentState = clientState.getCurrent()

    const currentPage: InitialPageInfo = {
      type: 'initial',
      page,
      timestamp: Date.now(),
    }

    currentState = clientState.update({ currentPage })

    const event: RouteChangeEvent = {
      event: 'routeChange',
      shopVersion: stringifyEventData([
        currentState.shop.appVersion,
        currentState.shop.gitHash,
      ]),
      shopId: getShopId(currentState.shop),
      timestamp: Date.now(),
      contentName: page.path,
      search: page.search,
      pageType: page.type,
      pageTypeId: null,
    }

    return event
  }
